

export const English = {

    MODULE: {
        LABEL: "Access",
    },

    LOGIN: {
        SEO_TITLE: "Sign in",
        SEO_DESCRIPTION: "Access to the project management system.",
        STATUS: "MANAGEMENT SYSTEM",
        EYEBROW: "Your work log",
        TITLE: "Welcome",
        TITLE_ACCENT: "back.",
        DESCRIPTION: "Companies, projects, work log, credentials and scripts. All in one place, on your own machine.",
        CARD_EYEBROW: "Private access",
        CARD_TITLE: "Sign in",
        CARD_SUBTITLE: "Enter your email and password.",
        SUBMIT: "Sign in",
        SUBMIT_LOADING: "Checking",
    },

    FIELDS: {
        EMAIL_LABEL: "Email",
        EMAIL_PLACEHOLDER: "you@domain.com",
        PASSWORD_LABEL: "Password",
        PASSWORD_PLACEHOLDER: "Your password",
        REMEMBER_ME: "Remember me",
    },


};
